import containerConnect from '@configuratorware/configurator-frontendgui/Framework/ComponentContainer';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import SendEmail from '@configuratorware/configurator-frontendgui/App/Shared/Components/SendEmail';
import { getConfiguration } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Selectors';
import { get } from 'lodash';

const mapStateToProps = ({ ui, configurator }) => {
  const { shareUrl } = getConfiguration(configurator);
  const { iso } = get(configurator.configuration, 'information.languageSettings');
  let language = 'de';
  switch (iso) {
    case 'en_GB': {
      language = 'en';
      break;
    }
    case 'fr_FR': {
      language = 'fr';
      break;
    }
    default: {
      //  language = "de"
    }
  }

  const url = shareUrl.replace('{lang}', language);

  return {
    Component: SendEmail,
    show: !!ui.visibilityMap.sendEmail,
    shareUrl: url,
  };
};

const mapDispatchToProps = () => ({
  onClose: () => Services.ui.hide('sendEmail'),
  onOkClick: () => Services.ui.hide('sendEmail'),
});

export default containerConnect(mapStateToProps, mapDispatchToProps);
